import PropTypes from 'prop-types';
import React from 'react';
import {
  useDispatch,
  useSelector,
} from 'react-redux';

import Alert from '@mui/material/Alert';
import Grid from '@mui/material/Grid';
import Planner from '../../../../../components/Planner';
import { setTimezones } from '../../../../../redux/app/actions';
import { getHorseLocations } from '../../../../../redux/horse/actions';

const SchedulesCardComponent = ({ id }) => {
  const dispatch = useDispatch();

  const [sortModel] = React.useState([
    {
      field: 'startDate',
      sort: 'desc',
    },
  ]);

  // Redux state
  const allBarnHorses = useSelector((state) => state.barn.allBarnHorses);
  const selectedBarnHorse = React.useMemo(
    () => allBarnHorses.find((barnHorse) => `${barnHorse.horse.id}` === `${id}`) || null,
    [allBarnHorses, id],
  );
  const [currentHorseLocations, setCurrentHorseLocations] = React.useState([]);
  const [horseLocationsLoaded, setHorseLocationsLoaded] = React.useState(false);

  React.useEffect(() => {
    dispatch(getHorseLocations(id, 0, 5, sortModel.map((s) => `&sort=${s.field},${s.sort}`))).then((horseLocations) => {
      if (horseLocations.content.length > 0) {
        const now = new Date();
        const sublist = horseLocations.content.filter((l) => new Date(l.startDate) < now
          && (l.endDate === null || new Date(l.endDate) > now));
        setCurrentHorseLocations(sublist);

        // setTimezone for horse current location
        if (sublist.length > 0) {
          dispatch(setTimezones(sublist[0].location.timezone))
        }
      } else {
        setCurrentHorseLocations([]);
      }
      setHorseLocationsLoaded(true);
    }).catch(() => {
      setCurrentHorseLocations([]);
      setHorseLocationsLoaded(true);
    });
  }, [id]);

  const showNoLocationAlert = horseLocationsLoaded && currentHorseLocations.length === 0;
  const showMultipleLocationsAlert = horseLocationsLoaded && currentHorseLocations.length > 1;

  return (
    <Grid container spacing={3}>
      {
        showNoLocationAlert && (
          <Grid size={12}>
            <Alert severity="info">
              This horse is not currently in a location.
            </Alert>
          </Grid>
        )
      }
      {
        showMultipleLocationsAlert && (
          <Grid size={12}>
            <Alert severity="info">
              This horse is currently in more than one location. The calendar is only showing tasks for the current planning location.
            </Alert>
          </Grid>
        )
      }
      <Grid size={12}>
        <Planner
          defaultView="calendar"
          defaultCalendarView="month"
          defaultBarnHorses={selectedBarnHorse
            ? [selectedBarnHorse]
            : []}
          navigate={() => { }}
          barnTasks={false}
          condensed
        />
      </Grid>
    </Grid>
  );
};

SchedulesCardComponent.propTypes = { id: PropTypes.any.isRequired };
SchedulesCardComponent.defaultProps = {};

export default SchedulesCardComponent;
